/**
 * Password policy — MUST stay in sync with the server's validatePasswordPolicy()
 * in server/src/auth/authService.ts. Duplicated here (rather than imported across
 * the client/server boundary) so the accept-invite and reset-password screens can
 * show the rules up front and reject bad input before hitting the API.
 */

export const PASSWORD_MIN_LENGTH = 10;

export const PASSWORD_RULES: string[] = [
  `At least ${PASSWORD_MIN_LENGTH} characters`,
  'At least one letter',
  'At least one number',
];

/** Returns the first policy violation message, or null if the password is valid. */
export function checkPasswordPolicy(password: string): string | null {
  if (password.length < PASSWORD_MIN_LENGTH) {
    return `Password must be at least ${PASSWORD_MIN_LENGTH} characters.`;
  }
  if (!/[a-zA-Z]/.test(password)) {
    return 'Password must contain at least one letter.';
  }
  if (!/[0-9]/.test(password)) {
    return 'Password must contain at least one number.';
  }
  return null;
}
